import {
  InstoreOrder,
  InstoreOrderClientFilters,
} from "../models/instoreOrder";

// Applies the client-side filters (models/instoreOrder.ts →
// InstoreOrderClientFilters) to an already loaded list. Pure, so the container
// can memoise it and any other consumer of the visible rows gets the same
// result.
//
// export_reference: case-insensitive "contains" — the reference is free text,
// so a partial term such as "wk43" must find "WK43-2026-A" as well. Rows
// without a reference (Opening / Relocation, or Week orders not exported yet)
// never match.
export default function filterInstoreOrdersByClientFilters(
  instoreOrders: InstoreOrder[],
  filters: InstoreOrderClientFilters,
): InstoreOrder[] {
  const term = filters.export_reference?.trim().toLowerCase();
  if (!term) return instoreOrders;
  return instoreOrders.filter((instoreOrder) =>
    (instoreOrder.export_reference ?? "").toLowerCase().includes(term),
  );
}
